import { render, staticRenderFns } from "./SelectObjectsButtonInput.vue?vue&type=template&id=9e3807c0&scoped=true&"
import script from "./SelectObjectsButtonInput.vue?vue&type=script&lang=js&"
export * from "./SelectObjectsButtonInput.vue?vue&type=script&lang=js&"
import style0 from "./SelectObjectsButtonInput.vue?vue&type=style&index=0&id=9e3807c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e3807c0",
  null
  
)

export default component.exports